import React from "react";
import LegalLayout, { H2, P } from "../components/LegalLayout";
import { ScaleIllustration } from "../components/legal/LegalIllustrations";

const SECTIONS = [
  { id: "publisher", labelFr: "Éditeur", labelEn: "Publisher" },
  { id: "hosting", labelFr: "Hébergement", labelEn: "Hosting" },
  { id: "ip", labelFr: "Propriété intellectuelle", labelEn: "Intellectual property" },
  { id: "liability", labelFr: "Responsabilité", labelEn: "Liability" },
  { id: "reporting", labelFr: "Signalement", labelEn: "Reporting" },
  { id: "law", labelFr: "Droit applicable", labelEn: "Governing law" },
];

export default function LegalNotices() {
  return (
    <LegalLayout
      titleFr="Mentions légales" titleEn="Legal Notices"
      taglineFr="Qui édite OLTODO, où nous contacter, et le droit applicable."
      taglineEn="Who publishes OLTODO, how to reach us, and governing law."
      updatedAt="9 septembre 2026"
      illustration={<ScaleIllustration />}
      sections={SECTIONS}
    >
      {(lang) => lang === "fr" ? (
        <>
          <H2 id="publisher">Éditeur du site et de l'application</H2>
          <P>
            SAS LNV (Les Nouvelles Visions), Société par Actions Simplifiée au capital de 100 000 €<br />
            Siège social, 50 avenue des Champs-Élysées, 75008 Paris, France<br />
            RCS Paris n° 109 515 288<br />
            SIRET, 109 515 288 00016<br />
            N° TVA intracommunautaire, FR86109515288<br />
            Directeur général, André PERRET<br />
            Directrice de la publication, Sofia MORATI<br />
            Directeur des Opérations, Marco BENLAID<br />
            Contact, contact@oltodo.com
          </P>

          <H2 id="hosting">Hébergement</H2>
          <P>
            Le site et l'application sont hébergés par Groupe LWS SARL,<br />
            2 rue Jules Ferry, 88190 Golbey, France.
          </P>

          <H2 id="ip">Propriété intellectuelle</H2>
          <P>
            L'ensemble des éléments du site et de l'application OLTODO (textes, graphismes, logo, icônes,
            structure) sont la propriété exclusive de SAS LNV, sauf mention contraire, et sont
            protégés par le droit d'auteur et le droit des marques. Toute reproduction non autorisée est
            interdite.
          </P>
          <P>
            Les contenus publiés par les utilisateurs (publications, photos, avis) restent la propriété de leurs
            auteurs, qui accordent à OLTODO une licence d'utilisation non exclusive nécessaire au fonctionnement
            du service (affichage, partage, modération), dans les conditions décrites dans les Conditions
            Générales d'Utilisation.
          </P>

          <H2 id="liability">Responsabilité</H2>
          <P>
            OLTODO met en relation des utilisateurs pour l'organisation d'activités et de rencontres. OLTODO
            n'est pas organisateur des activités proposées par ses utilisateurs et ne saurait être tenu
            responsable du déroulement de celles-ci, sous réserve des dispositions légales applicables. Chaque
            utilisateur reste seul responsable des informations qu'il publie et de son comportement, y compris
            hors de l'application.
          </P>

          <H2 id="reporting">Signalement</H2>
          <P>
            Pour signaler un contenu ou un comportement inapproprié, utilise la fonction de signalement intégrée
            à l'application, décrite dans les Règles de la communauté, ou contacte contact@oltodo.com.
          </P>

          <H2 id="law">Droit applicable</H2>
          <P>Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux
          compétents seront ceux du ressort du siège social de SAS LNV (Paris), sauf
          disposition d'ordre public contraire.</P>
        </>
      ) : (
        <>
          <H2 id="publisher">Publisher</H2>
          <P>
            SAS LNV (Les Nouvelles Visions), a French simplified joint-stock company (SAS) with share
            capital of €100,000<br />
            Registered office, 50 avenue des Champs-Élysées, 75008 Paris, France<br />
            Company registration number (RCS Paris), 109 515 288<br />
            SIRET, 109 515 288 00016<br />
            VAT number, FR86109515288<br />
            Chief Executive Officer, André PERRET<br />
            Publication director, Sofia MORATI<br />
            Chief Operating Officer, Marco BENLAID<br />
            Contact, contact@oltodo.com
          </P>

          <H2 id="hosting">Hosting</H2>
          <P>
            The website and application are hosted by Groupe LWS SARL,<br />
            2 rue Jules Ferry, 88190 Golbey, France.
          </P>

          <H2 id="ip">Intellectual Property</H2>
          <P>
            All elements of the OLTODO website and application (text, graphics, logo, icons, structure) are the
            exclusive property of SAS LNV, unless otherwise stated, and are protected by
            copyright and trademark law. Unauthorized reproduction is prohibited.
          </P>
          <P>
            Content posted by users (publications, photos, reviews) remains the property of their authors, who
            grant OLTODO a non-exclusive license necessary for the operation of the service (display, sharing,
            moderation), under the terms described in the Terms of Use.
          </P>

          <H2 id="liability">Liability</H2>
          <P>
            OLTODO connects users for the organization of activities and meetups. OLTODO is not the organizer of
            activities proposed by its users and cannot be held liable for their conduct, subject to applicable
            legal provisions. Each user remains solely responsible for the information they post and their
            behavior, including outside the application.
          </P>

          <H2 id="reporting">Reporting</H2>
          <P>
            To report inappropriate content or behavior, use the in-app reporting feature, described in the
            Community Rules, or contact contact@oltodo.com.
          </P>

          <H2 id="law">Governing Law</H2>
          <P>These legal notices are governed by French law. In the event of a dispute, the competent courts
          will be those of the jurisdiction of the registered office of SAS LNV (Paris),
          subject to any overriding mandatory provisions.</P>
        </>
      )}
    </LegalLayout>
  );
}
